module.exports = __webpack_public_path__ + "img/entrance_plant_3.04155a72.jpg";